<template>
  <div class="apply_container">
    <div class="navbar">
      <span>{{ type ? '课程' : '活动' }}报名</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="apply_content">
      <div class="activity_name">{{ name }}</div>
      <div class="apply_peoples">
        <div class="total d-f jc-sb ai-c">
          <div class="num">
            <span>报名人员</span
            ><span v-if="contactList.length > 0">
              <!-- （0/{{ contactList.length }}） -->
            </span>
          </div>
          <div class="add_icon gray" v-if="contactList.length >= 10">
            <span>至多添加10位人员</span>
          </div>
          <div class="add_icon" @click="addPeople" v-else>
            <img src="@/assets/images/detail/performance/add.png" alt="" />
            <span>添加</span>
          </div>
        </div>
        <div class="tip">
          <img src="@/assets/images/detail/gantan.png" alt="" />
          <span>65周岁以上老人与16周岁以下儿童可由他人代报</span>
        </div>
        <div v-for="(item, index) in contactList" :key="index">
          <div class="people d-f ai-c jc-sb">
            <div class="d-f ai-c">
              <div @click="selectContact(item, index)">
                <img src="@/assets/images/detail/performance/checked.png" alt="" class="select_icon select" v-if="checkedId[index]" />
                <div class="no_select" v-else></div>
              </div>
              <div>
                <div class="name d-f ai-c">
                  <span>{{ item.name }}</span>
                  <span class="tag" v-if="index == 0">本人</span>
                </div>
                <div class="phone">{{ handleDecryptPhone(item.phone) }}</div>
                <div class="identity_card">{{ handleDecryptCard(item.credentialsCode) }}</div>
              </div>
            </div>
            <div class="d-f ai-c icon_right" v-if="index != 0">
              <div class="d-f fxd-c ai-c icon_item" @click="editContact(item, index)">
                <img src="@/assets/images/detail/performance/edit.png" alt="" class="select_icon" />
                <span>编辑</span>
              </div>
              <div class="d-f fxd-c ai-c" @click="delContact(item)">
                <img src="@/assets/images/detail/performance/delete.png" alt="" class="select_icon" />
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="summit_button">
        <div class="btn" @click="signUp">立即报名</div>
      </div>

      <van-popup v-model="addShow" round position="bottom" :style="{ height: '60%' }" class="popup">
        <div class="title">添加成员</div>
        <img src="@/assets/images/detail/performance/close.png" alt="" class="close_icon" @click="addShow = false" />
        <div class="form">
          <van-form ref="form">
            <van-field v-model="form.name" label="姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field readonly clickable name="picker" v-model="value1" label="证件类型" @click="showPicker = true" :rules="[{ required: true, message: '请选择证件类型' }]">
              <template slot="right-icon">
                <van-icon name="arrow-down" />
              </template>
            </van-field>
            <van-field v-model="form.credentialsCode" label="证件号" :rules="credentialsRules" />
            <van-field v-model="form.phone" label="手机号" :rules="phoneRules" />
            <div class="summit_button" @click="onSubmit">
              <div class="btn">确认</div>
            </div>
          </van-form>
        </div>
      </van-popup>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false">
        <template #option="option">
          <div>{{ option.dictValue }}</div></template
        >
      </van-picker>
    </van-popup>
    <van-popup :round="true" v-model="showAuthentication">
      <div class="authentication_box d-f fxd-c ai-c jc-c">
        <img src="../../assets/images/detail/img_name.png" alt="" class="img_name" />
        <div class="box_title">实名认证</div>
        <div class="sub_title">获取你的实名信息将用于为你实现快捷报名、预约等操作</div>
        <div class="name_btn box_btn" @click="handleAuthentication">立即实名</div>
        <div class="cancle_btn box_btn" @click="showAuthentication = false">取消</div>
      </div></van-popup
    >
  </div>
</template>
<script>
import { artTrainSignUp } from '@/api/cultivate'
import { contactsList, contactsAdd, contactsEdit, contactsDelete } from '@/api/contacts'
import { getDictByCode } from '@/api/common'
import { activitySignUp, getUserInfo } from '@/api/activity'
import { encrypt, decrypt } from '@/utils/sm4'
export default {
  data() {
    return {
      addShow: false,
      showPicker: false,
      showAuthentication: false,
      value1: '身份证',
      columns: [],
      form: {},
      name: '',
      id: '',
      singleMaxNumber: 0,
      editId: '',
      type: '',
      contactList: [],
      checkedId: [],
      credentialsRules: [
        { required: true, message: '请填写证件号' },
        {
          validator: (value) => {
            return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
          },
          message: '身份证号有误',
        },
      ],
      phoneRules: [
        { required: true, message: '请填写手机号' },
        {
          validator: (value) => {
            return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)
          },
          message: '手机号有误',
        },
      ],
    }
  },
  methods: {
    addPeople() {
      this.addShow = true
      this.form = {
        name: '',
        credentialsCode: '',
        phone: '',
      }
      // this.form.name = ''
      // this.form.credentialsCode = ''
      // this.form.phone = ''
    },
    // 获取证件类型
    getdict() {
      console.log('获取证件类型')

      getDictByCode('CREDENTIALS_TYPE').then((res) => {
        this.columns = res.result

        this.value1 = res.result[0].dictValue
        this.form.credentialsType = res.result[0].dictKey
      })
    },
    handleDecryptCard(value) {
      return decrypt(value).replace(/(\w{5})\w*(\w{4})/, '$1********$2')
    },
    handleDecryptPhone(value) {
      return decrypt(value).replace(/(\w{3})\w*(\w{4})/, '$1****$2')
    },
    getContacts() {
      contactsList().then((res) => {
        console.log(res)
        this.contactList = res.result
        this.form = {}
        this.checkedId = []
        this.checkedId.push(this.contactList[0].id)
      })
    },
    selectContact(item, index) {
      if (this.checkedId[index]) {
        this.checkedId[index] = undefined
      } else {
        if (this.type) {
          // 课程报名单选人员
          this.checkedId = []
          this.checkedId[index] = item.id
        } else {
          // 活动报名可多选人员
          const personId = this.checkedId.filter((item) => {
            return item
          })
          if (this.singleMaxNumber > 0 && personId.length >= this.singleMaxNumber) {
            this.$cue.toast('单次限制报名人数为' + this.singleMaxNumber)
            return
          }
          this.checkedId[index] = item.id
        }
      }
      console.log(this.checkedId)
      this.$forceUpdate()
    },
    editContact(item) {
      this.addShow = true
      this.form = { ...item, credentialsCode: decrypt(item.credentialsCode), phone: decrypt(item.phone) }
      this.columns.forEach((ele) => {
        if (ele.dictKey == item.credentialsType) {
          this.value1 = ele.dictValue
        }
      })
    },
    delContact(item) {
      contactsDelete(item.id).then((res) => {
        if (res.code == 2000) {
          this.getContacts()
        }
      })
    },
    onSubmit() {
      this.$refs.form
        .validate()
        .then(() => {
          //  验证通过
          console.log(this.form)
          if (!this.form.credentialsType) {
            this.form.credentialsType = 1
          }
          const params = { ...this.form, credentialsCode: encrypt(this.form.credentialsCode), phone: encrypt(this.form.phone) }
          console.log('加密后的数据====>', params)
          if (this.form.id) {
            this.edit(params)
          } else {
            this.add(params)
          }
        })
        .catch(() => {})
    },
    add(data) {
      contactsAdd(data).then((res) => {
        if (res.code == 2000) {
          this.showPicker = this.addShow = false
          this.getContacts()
        }
      })
    },
    edit(data) {
      contactsEdit(data).then((res) => {
        if (res.code == 2000) {
          this.showPicker = this.addShow = false
          this.getContacts()
        }
      })
    },

    signUp() {
      const personId = this.checkedId.filter((item) => {
        return item
      })
      console.log(personId)
      console.log(111)
      if (personId.length == 0) {
        this.$cue.toast('请选择报名人员')
        return
      }
      // if (this.type && personId.length > 1) {
      //   this.$cue.toast('报名人员最多一人')
      //   return
      // }
      console.log(222)
      const data = { id: this.id, personId }
      // 判断是否实名
      getUserInfo().then((res) => {
        if (res.result.authenticationFlag == 0) {
          this.showAuthentication = true
        } else {
          this.apply(data)
        }
      })
    },
    handleAuthentication() {
      this.$myUni.navigateTo({
        url: '/pages/login/authentication',
      })
    },
    apply(data) {
      if (this.type) {
        let params = {}
        let item_person = {}
        // 课程报名
        console.log(data.personId)
        this.contactList.forEach((item) => {
          if (item.id == data.personId[0]) {
            item_person = { ...item }
          }
        })
        item_person.name = encrypt(item_person.name)
        const { credentialsType, name, credentialsCode, phone } = item_person
        // console.log(name)
        // let newName = encrypt(name)
        params = { trainId: data.id, credentialsType, name, credentialsCode, phone }
        console.log('params====>', params)
        artTrainSignUp(params).then((res) => {
          if (res.code == 2000) {
            this.$router.push({
              path: '/detail/registrationResult',
              query: {
                type: 'offlineTraining',
              },
            })
          }
        })
      } else {
        // 活动报名
        activitySignUp(data).then((res) => {
          if (res.code == 2000) {
            this.$router.push({
              path: '/detail/registrationResult',
            })
          }
        })
      }
    },
    onConfirm(value) {
      console.log(value)
      this.value1 = value.dictValue
      this.form.credentialsType = value.dictKey
      this.showPicker = false
    },
    back() {
      this.$router.go(-1)
    },
  },
  mounted() {
    const { id, name, singleMaxNumber } = this.$route.query
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    this.name = name
    this.id = id
    this.singleMaxNumber = singleMaxNumber
    this.getdict()
    this.getContacts()
  },
}
</script>
<style lang="scss">
.apply_container {
  width: 100%;
  height: 100vh;
  background: #fff;
  .authentication_box {
    padding: 1.6rem 1.15rem 1.2rem 1.2rem;
    width: 16.35rem;
    // height: 17.8rem;
    background: #ffffff;
    border-radius: 0.4rem;
    .img_name {
      width: 4.4rem;
      height: 4.4rem;
      margin-bottom: 0.6rem;
    }
    .box_title {
      font-size: 1rem;
      font-weight: 600;
      color: #000000;
      line-height: 1.4rem;
    }
    .sub_title {
      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      text-align: center;
      margin: 0.8rem 0 1.2rem 0;
    }
    .box_btn {
      width: 13.95rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      border-radius: 1.1rem;
      font-size: 0.8rem;
      color: #a97048;
      border: 1px solid #a97048;

      &.name_btn {
        color: #ffffff;
        background: #a97048;
        margin-bottom: 0.6rem;
      }
    }
  }

  .navbar {
    z-index: 10;
    width: 100%;
    height: 44px;
    position: fixed;
    top: calc(44px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    border-bottom: 1px solid #f4f4f4;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .apply_content {
    padding: 0 0.6rem;
    width: 100%;
    height: calc(100% - 88px - env(safe-area-inset-top));
    position: absolute;
    top: calc(88px + env(safe-area-inset-top));
    left: 0;
    overflow-y: auto;
    padding-bottom: calc(3rem + env(safe-area-inset-bottom));
  }

  .popup {
    padding: 0.8rem 0.6rem 0 0.6rem;
    .van-field__control,
    .van-field__error-message {
      text-align: right !important;
    }
    .form {
      margin-top: 0.5rem;
    }
    .title {
      width: 100%;
      text-align: center;
      font-size: 0.8rem;
      font-weight: 600;
      color: #000000;
    }
    .close_icon {
      position: absolute;
      top: 1.05rem;
      right: 0.9rem;
      width: 0.7rem;
      height: 0.7rem;
    }
  }
  .activity_name {
    font-size: 0.9rem;
    font-weight: 600;
    color: #212121;
    line-height: 0.9rem;
    padding: 0.75rem 0 0.6rem 0;
    border-bottom: 1px solid #eeeeee;
  }
  .apply_peoples {
    .total {
      margin-top: 0.85rem;
      margin-bottom: 0.95rem;
      .add_icon {
        padding: 0 0.8rem;
        height: 1.4rem;
        line-height: 1.4rem;
        border-radius: 14px;
        // border: 1px solid #47988a;
        border: 1px solid #a97048;
        text-align: center;
        font-size: 0.6rem;
        // color: #47988a;
        color: #a97048;
        &.gray {
          border: 1px solid #999 !important;
          color: #999;
        }
        img {
          width: 10px;
          height: 10px;
          margin-right: 3px;
        }
      }

      .num {
        font-size: 0.8rem;
        font-weight: 600;
        color: #212121;
        line-height: 1.2rem;
        :last-child {
          margin-left: 0.3rem;
          font-weight: 400;
          color: #666666;
          font-size: 0.7rem;
        }
      }
    }
    .select_icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-bottom: 2px;
    }
    .people {
      width: 100%;
      // height: 78px;
      background: #f7f7f7ff;
      border: 1px dotted rgb(224, 224, 224);
      margin-bottom: 0.6rem;
      padding: 0.5rem 0.6rem;
      .select {
        margin: 0 0.6rem 0 0;
      }
      .no_select {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.1rem;
        border: 1px solid #999999;
        margin: 0 0.6rem 0 0;
      }

      .icon_right {
        font-size: 0.5rem;
        color: #666666;
        line-height: 0.6rem;
        .icon_item {
          margin-right: 0.6rem;
        }
      }
      .name {
        font-size: 0.7rem;
        font-weight: 600;
        color: #212121;
        line-height: 1rem;
        margin-bottom: 0.2rem;
        .tag {
          margin-left: 4px;
          padding: 0 2px;
          height: 0.6rem;
          font-size: 9px;
          color: #666666;
          line-height: 0.6rem;
          border-radius: 2px;
          border: 1px solid #666666;
          text-align: center;
        }
      }
      .phone,
      .identity_card {
        font-size: 0.6rem;
        color: #666666;
        line-height: 0.8rem;
      }
      .phone {
        margin-bottom: 2px;
      }
    }
  }
}
.tip {
  // width: 12.75rem;
  height: 0.8rem;
  font-size: 0.6rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.8rem;
  color: #666666;
  display: flex;
  align-items: center;
  margin: 12px 0 10px;
  img {
    width: 0.6rem;
    height: 0.6rem;
    margin: 0.2rem;
  }
}
</style>
